<template>
  <v-app id="App">

    <el-scrollbar class="ShowHeaderApplication">
      <router-view @back_disable="back_disable1" />
    </el-scrollbar>

    <bottomNavigation v-if="btnShowNavbar"></bottomNavigation>
  </v-app>
</template>

<script>
import bottomNavigation from "./components/bottomNavigation";
export default {
  name: "App",
  components: {
    bottomNavigation,
  },
  data(){
    return{
      btnShowNavbar: true
    }
  },

  mounted() {
    this.$vuetify.rtl = true;
    this.updateAuth();

    if (this.$store.getters.auth.loggedIn && this.$router.path == '/login'){
      this.$router.push({ path: "/" });
    }
  },
  methods: {
    back_disable1() {
      this.btnShowNavbar = false
    },

    updateAuth() {
      this.$store.dispatch("checkToken");
    },
  },
};
</script>

<style>

</style>
